import { programmatic } from './programmatic';
import { tradingDesk } from './tradingDesk';

export const graphqlAPI = {
  programmatic,
  tradingDesk,
};
